'use strict';

angular.module('app.cdnUrl.cdnUrlFilter', [])
    .filter('cdn_url', [
        'cdnUrl',
        function (cdnUrl) {
            return function (input, index) {
                if (input && !input.match(/^http/)) {
                    input = input.replace(/^\//, '');

                    index = parseInt(index);
                    if(isNaN(index)){
                        index = 0;
                    }

                    return cdnUrl[index] + '/' + input;
                } else {
                    return input;
                }
            };
        }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/fhApp/cdnUrl/cdnUrlFilter.js